import { useState } from "react"
import { Appointment } from "../../../pages/platform/components/Appointment"
import { OldAppointmentWidget, SmallAppointmentWidget } from "../../../pages/platform/components/NewAppointmentWidget"
import { useAuth } from "../../../utils/context/AuthContext"
import { useUserData } from "../../../utils/context/UserDataContext"
import { AppointmentStatus, ExpertRole } from "../../../utils/Enums"

const AppointmentsBox: React.FC<{ appointments: Appointment[] }> = ({
  appointments,
}) => {
  console.log("appointments", appointments);
  const { auth } = useAuth()
  const role = auth.role
  const { userData } = useUserData()
  const email = userData.email
  const fullVisibility = role === (ExpertRole.Admin || role === ExpertRole.Specialist) ? true : false

  const filteredAppointments = fullVisibility ?
    appointments.filter((appointment) => appointment.status === AppointmentStatus.Active) :
    appointments
      .filter((appointment) => appointment.expert_email === email || appointment.expert_email === "dr.gentilesalvatore@gmail.com" || appointment.expert_email === "admin@holifya.com")
      .filter((appointment) => appointment.status === AppointmentStatus.Active)
  const oldAppointments = filteredAppointments.filter((appointment) => appointment.remainingMinutes <= -30)
  const futureAppointments = filteredAppointments.filter((appointment) => appointment.remainingMinutes > -30)

  const [isExpanded, setIsExpanded] = useState(true);

  const handleToggle = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <div className="space-y-[25px] border rounded-xl p-2 border border-solid border-holifya-grey-shadow shadow-platform-new">
      <div className="font-bold text-[16px] leading-[33px] flex justify-between items-center">
        <span>Appuntamenti</span>
        <button
          onClick={handleToggle}
          className="text-blue-500 text-sm">
          {isExpanded ? "Mostra meno" : "Mostra di più"}
        </button>
      </div>
      {isExpanded && (<div className="space-y-[20px]">
      {
        futureAppointments.map((app, index) =>
          <SmallAppointmentWidget
            key={index}
            appointment={app}
          />
        )
      }
      {
        oldAppointments.map((app, index) =>
          <OldAppointmentWidget
            key={index}
            appointment={app}
          />
        )
      }
      </div>
      )}
    </div>
  )
}

export default AppointmentsBox
